module Bookhus {

    export class SearchLanguage {
        constructor() {

        }
        private translations: any = {
            da: {
                AntalPersoner: "Antal personer",
                AntalSoveværelser: "Antal soveværelser",
                Bjergby: "Bjergby",
                Brændeovn: "Brændeovn",
                Boat: "Båd",
                Cykler: "Cykler",
                Dag: "dag",
                Dage: "dage",
                Ekkolod: "Ekkolod",
                Faciliteter: "Faciliteter",
                Feriecenter: "Feriecenter",
                Fiskerenseplads: "Fiskerenseplads",
                Garage: "Garage",
                Handicapvenligt: "Handicapvenligt",
                HavDistance: "Afstand til havet",
                Havudsigt: "Havudsigt",
                Hus: "Hus",
                Husdyr: "Husdyr",
                HusdyrIkkeTilladt: "Ingen husdyr tilladt",
                IkkeValgt: "Ikke valgt",
                PoolIn: "Indendørs pool",
                Internet: "Internet",
                KøbmandDistance: "Afstand til købmanden",
                Lejlighed: "Lejlighed",
                Lokation: "Alle steder",
                Beliggenhed: "Beliggenhed",
                Mikroovn: "Mikroovn",
                Nulstil: "Nulstil",
                Område: "Område",
                Opvaskemaskine: "Opvaskemaskine",
                Parabol: "Parabol",
                Periode: "Periode",
                Person: "Person",
                Personer: "Personer",
                Radar: "Radar",
                VhsRadio: "Vhs radio",
                Rygning: "Rygning",
                Sauna: "Sauna",
                Skiområde: "Skiområde",
                Spa: "Spa",
                StartDato: "Startdato",
                Storby: "Storby",
                Swimmingpool: "Svømmepøl",
                Søg: "Søg",
                MinTwoToilets: "2. toiletter",
                Tørretumbler: "Tørretumbler",
                PoolOut: "Udendørs pool",
                UdsigtNatur: "Natur udsigt",
                UdsigtVand: "Vandudsigt",
                Uge: "Uge",
                Uger: "Uger",
                Under: "Under",
                Vaskemaskine: "Vaskemaskine",
                VisKatalog: "Vis i katalog",
                Værelse: "Værelse",
                Værelser: "Værelser",
                AdvancedSearch: "Avanceret søgning"
            },
            'en-GB': {
                AntalPersoner: "Number of persons",
                AntalSoveværelser: "Number of bedrooms",
                Bjergby: "Mountain city",
                Brændeovn: "Wood stove",
                Boat: "Boat",
                Cykler: "Cycles",
                Dag: "Day",
                Dage: "Days",
                Ekkolod: "Sonar",
                Faciliteter: "Facilities",
                Feriecenter: "",
                Fiskerenseplads: "Fish cleaning table",
                Garage: "Garage",
                Handicapvenligt: "Disabled friendly",
                HavDistance: "Distance to the sea",
                Havudsigt: "Sea views",
                Hus: "House",
                Husdyr: "Pets",
                HusdyrIkkeTilladt: "Pets not allowed",
                IkkeValgt: "Not selected",
                PoolIn: "Indoor pool",
                Internet: "Internet",
                KøbmandDistance: "Distance to the merchant",
                Lejlighed: "Apartment",
                Beliggenhed: "All locations",
                Location: "Location",
                Mikroovn: "Mircowave",
                Nulstil: "Reset",
                Område: "Area",
                Opvaskemaskine: "Dishwasher",
                Parabol: "Satellite",
                Periode: "Period",
                Person: "Person",
                Personer: "Persons",
                Radar: "Radar",
                VhsRadio: "Vhs radio",
                Rygning: "Smoking",
                Sauna: "Sauna",
                Skiområde: "Skiområde",
                Spa: "Spa",
                StartDato: "Startdate",
                Storby: "City",
                Swimmingpool: "Swimmingpool",
                Søg: "Search",
                MinTwoToilets: "2. toilets",
                Tørretumbler: "Dryer",
                PoolOut: "Outdoor pool",
                UdsigtNatur: "Nature view",
                UdsigtVand: "Water view",
                Uge: "Week",
                Uger: "Weeks",
                Under: "Under",
                Vaskemaskine: "Washing machine",
                VisKatalog: "Show in catalog",
                Værelse: "Room",
                Værelser: "Rooms",
                AdvancedSearch: "Advanced search"
            },
            sv: {
                AntalPersoner: "Antal personer",
                AntalSoveværelser: "Antal rum",
                Bjergby: "Bjergby",
                Brændeovn: "Brasa",
                Boat: "Båt",
                Cykler: "Cyklar",
                Dag: "dag",
                Dage: "dagar",
                Ekkolod: "Ekolod",
                Faciliteter: "Faciliteter",
                Feriecenter: "Semesterort",
                Fiskerenseplads: "Fiskrensbord",
                Garage: "Garage",
                Handicapvenligt: "Handikappvänlig",
                HavDistance: "Avstånd till havet",
                Havudsigt: "Havsutsikt",
                Hus: "Hus",
                Husdyr: "Husdjur",
                HusdyrIkkeTilladt: "Husdjur inte tillåtna",
                IkkeValgt: "Inte vald",
                PoolIn: "Inomhuspool",
                Internet: "Internet",
                KøbmandDistance: "Avstånd till köpman",
                Lejlighed: "Lägenhet",
                Beliggenhed: "Alla platser",
                Location: "Plats",
                Mikroovn: "Mikrovågsugn",
                Nulstil: "Återståll",
                Område: "Område",
                Opvaskemaskine: "Diskmaskin",
                Parabol: "Parabol",
                Periode: "Period",
                Person: "Person",
                Personer: "Människor",
                Radar: "Radar",
                VhsRadio: "Vhs radio",
                Rygning: "Rökning",
                Sauna: "Bastu",
                Skiområde: "Skiområde",
                Spa: "Spa",
                StartDato: "Startdatum",
                Storby: "Stad",
                Swimmingpool: "pool",
                Søg: "Sök",
                MinTwoToilets: "2. toaletter",
                Tørretumbler: "Torktumlare",
                PoolOut: "Utomhuspool",
                UdsigtNatur: "Naturvyn",
                UdsigtVand: "Vatten visa",
                Uge: "Vecka",
                Uger: "Veckor",
                Under: "Nedan",
                Vaskemaskine: "Tvättmaskin",
                VisKatalog: "VIsa i katalogen",
                Værelse: "Rum",
                Værelser: "Rum",
                AdvancedSearch: "avancerad sökning"
            },
            de: {
                AntalPersoner: "Anzahl der Personen",
                AntalSoveværelser: "Anzahl der Schlafzimmer",
                Bjergby: "",
                Brændeovn: "Holzofen",
                Boat: "Boot",
                Cykler: "Fahrräder",
                Dag: "Tag",
                Dage: "Tage",
                Ekkolod: "Sonar",
                Faciliteter: "Einrichtungen",
                Feriecenter: "",
                Fiskerenseplads: "Fischreinigungs",
                Garage: "Garage",
                Handicapvenligt: "Behindertengerecht",
                HavDistance: "Nähe zum Meer",
                Havudsigt: "Meerblick",
                Hus: "",
                Husdyr: "Haustiere",
                HusdyrIkkeTilladt: "Haustiere nicht erlaubt",
                IkkeValgt: "Nicht ausgewählt",
                PoolIn: "Hallenbad",
                Internet: "Internet",
                KøbmandDistance: "Entfernung zum Lebensmittelgeschäft",
                Lejlighed: "",
                Beliggenhed: "Überall",
                Location: "Lage",
                Mikroovn: "Mikrowelle",
                Nulstil: "rücksetzen",
                Område: "Bereich",
                Opvaskemaskine: "Spülmaschine",
                Parabol: "Sat. Anschluss",
                Periode: "Zeit",
                Person: "Person",
                Personer: "Leute",
                Radar: "Radar",
                VhsRadio: "Vhs radio",
                Rygning: "Rauchen",
                Sauna: "Sauna",
                Skiområde: "",
                Spa: "Whirrlpool",
                StartDato: "Startdatum",
                Storby: "",
                Swimmingpool: "",
                Søg: "Suche",
                MinTwoToilets: "2. Toiletten",
                Tørretumbler: "Trockner",
                PoolOut: "Freibad",
                UdsigtNatur: "",
                UdsigtVand: "",
                Uge: "Woche",
                Uger: "Wochen",
                Under: "Unter",
                Vaskemaskine: "Waschmachine",
                VisKatalog: "In Katalog",
                Værelse: "Zimmer",
                Værelser: "Zimmer",
                AdvancedSearch: "erweiterte Suche"
            },
            no: {
                AntalPersoner: "Antall personer",
                AntalSoveværelser: "Antall rom",
                Bjergby: "",
                Brændeovn: "Vedovn",
                Boat: "Båt",
                Cykler: "Sykler",
                Dag: "dag",
                Dage: "dager",
                Ekkolod: "Ekkolodd",
                Faciliteter: "Fasiliteter",
                Feriecenter: "",
                Fiskerenseplads: "Sløye",
                Garage: "Garasje",
                Handicapvenligt: "Hendicapvenligt",
                HavDistance: "Avstand til sjøen",
                Havudsigt: "Sjø",
                Hus: "",
                Husdyr: "Husdyr",
                HusdyrIkkeTilladt: "Husdyr ikke tillatt",
                IkkeValgt: "Ikke valgt",
                PoolIn: "Innendørs basseng",
                Internet: "Internett",
                KøbmandDistance: "Avstand til matbutikk",
                Lejlighed: "",
                Beliggenhed: "Alle steder",
                Location: "Plassering",
                Mikroovn: "Mikrobølgeovn",
                Nulstil: "Tilbakestille",
                Område: "Område",
                Opvaskemaskine: "Oppvaskmaskin",
                Parabol: "Parabol",
                Periode: "Periode",
                Person: "Person",
                Personer: "Mennesker",
                Radar: "Radar",
                VhsRadio: "Vhs radio",
                Rygning: "Røyking",
                Sauna: "Badstue",
                Skiområde: "",
                Spa: "Spa",
                StartDato: "Startdato",
                Storby: "",
                Swimmingpool: "",
                Søg: "Søk",
                MinTwoToilets: "2. toaletter",
                Tørretumbler: "Tørketrommel",
                PoolOut: "Utendørs basseng",
                UdsigtNatur: "",
                UdsigtVand: "",
                Uge: "Uke",
                Uger: "Uker",
                Under: "Under",
                Vaskemaskine: "Vaskemaskine",
                VisKatalog: "Vis i katalog",
                Værelse: "Rom",
                Værelser: "Rom",
                AdvancedSearch: "avansert søk"
            }
        }
        private iteration = 0;
        private deadlock = 1;
        get(name: string, lang?: string): string {            
            var langCode = $.datepicker.regional.bookhuscurrent as string;
            if (lang != undefined && lang != null) {
                langCode = lang;
            }
            
            if (this.translations[langCode] == undefined || this.translations[langCode] == null) {
                return "Oversættelse findes ikke";
            }

            var value = this.translations[langCode][name];
            if (value == undefined || value == "") {
                if (this.iteration >= this.deadlock) {
                    this.iteration = 0;
                    return "Oversættelse findes ikke";
                }
                this.iteration++;
                return this.get(name, "da");
            }
            this.iteration = 0;
            return value;
        }
        
    }
}

var language = new Bookhus.SearchLanguage();
